import { render, staticRenderFns } from "./AddProjectTeamMember.vue?vue&type=template&id=6aa90184&scoped=true&"
import script from "./AddProjectTeamMember.vue?vue&type=script&lang=js&"
export * from "./AddProjectTeamMember.vue?vue&type=script&lang=js&"
import style0 from "./AddProjectTeamMember.vue?vue&type=style&index=0&id=6aa90184&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aa90184",
  null
  
)

export default component.exports